export default __webpack_public_path__ + "static/rotate-icon-predict-cb441c0e31f53103e8977a901397fe0c.svg";